import React from "react";

const CategoryTag = ({ name }) => {
  return (
    <li className="mr-4 p-2 bg-grey-lightest text-grey text-xs rounded mt-2 md:mt-1 md:mt-0">
      {name}
    </li>
  );
};

export default CategoryTag;
